import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _combineReducers;

import { combineReducers } from 'redux';
import onboardingFlow from "./onboarding";
import onboardingGenericFlow from "./onboarding-generic";
import TUActivationFlow from "./tu-activation";
import basic from "./basic";
import yodlee from "./yodlee";
import creditScore from "./credit-score";
import noSecurityQuestion from "./no-security-question";
import onboardingDebt from "./onboarding-debt";
import antiFraud from "./anti-fraud";
import { FlowId } from "../../constants";
export default combineReducers((_combineReducers = {}, _defineProperty(_combineReducers, FlowId.ONBOARDING, onboardingFlow), _defineProperty(_combineReducers, FlowId.ONBOARDING_GENERIC, onboardingGenericFlow), _defineProperty(_combineReducers, FlowId.TU_ACTIVATION, TUActivationFlow), _defineProperty(_combineReducers, FlowId.BASIC, basic), _defineProperty(_combineReducers, FlowId.ACCOUNT_AGG, yodlee), _defineProperty(_combineReducers, FlowId.CREDIT_SCORE, creditScore), _defineProperty(_combineReducers, FlowId.NO_SECURITY_QUESTION, noSecurityQuestion), _defineProperty(_combineReducers, FlowId.ONBOARDING_DEBT, onboardingDebt), _defineProperty(_combineReducers, FlowId.ANTI_FRAUD, antiFraud), _combineReducers));